import styled, { css } from 'styled-components';
import PagebuilderListWrapper from 'gatsby-theme-pagebuilder/src/components/blocks/list/wrapper';

const gridStyles = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.grid.containerGap};

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const PDVListWrapper = styled(PagebuilderListWrapper)`
  ${({ $variant }) => $variant === 'standout' && css`
    ${gridStyles}
  `}
  ${({ $variant }) => $variant === 'horizontal' && css`
    ${gridStyles}
  `}
  ${({ $variant }) => $variant === 'buttons' && css`
    ${gridStyles}
  `}
`;

export default PDVListWrapper;
